export enum ReasonType {
    DEATH = 'DeathReason',
    DISCARD = 'DiscardReason',
    SALE = 'SaleReason'
}
